import type { ReactNode } from 'react';

export const MirageWrapper = ({ children }: { children: ReactNode }) => <>{children}</>;
